import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from './Button';
export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const scrollToSection = (id: string) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-[#1e3a5f] text-white shadow-lg" data-id="element-70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-71">
        <div className="flex justify-between items-center h-20" data-id="element-72">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center cursor-pointer" onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} data-id="element-73">
            <span className="font-black text-xl md:text-2xl tracking-tight" data-id="element-74">
              Sistema PRO<span className="text-[#d4a017]" data-id="element-75">.</span>
            </span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-76">
            <button onClick={() => scrollToSection('tomos')} className="text-gray-200 hover:text-white font-medium transition-colors" data-id="element-77">
              Tomos
            </button>
            <button onClick={() => scrollToSection('bonos')} className="text-gray-200 hover:text-white font-medium transition-colors" data-id="element-78">
              Bonos
            </button>
            <button onClick={() => scrollToSection('testimonios')} className="text-gray-200 hover:text-white font-medium transition-colors" data-id="element-79">
              Testimonios
            </button>
            <button onClick={() => scrollToSection('pricing')} className="bg-[#d4a017] hover:bg-[#e5b229] text-[#1e3a5f] font-bold py-2.5 px-6 rounded-lg transition-colors shadow-md" data-id="element-80">
              COMPRAR AHORA
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-81">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-gray-200 hover:text-white focus:outline-none" data-id="element-82">
              {isMobileMenuOpen ? <XIcon className="h-7 w-7" data-id="element-83" /> : <MenuIcon className="h-7 w-7" data-id="element-84" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-[#162d4a] border-t border-[#1e3a5f]" data-id="element-85">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-86">
            <button onClick={() => scrollToSection('tomos')} className="block w-full text-left px-3 py-3 text-base font-medium text-gray-200 hover:text-white hover:bg-[#1e3a5f] rounded-md" data-id="element-87">
              Tomos
            </button>
            <button onClick={() => scrollToSection('bonos')} className="block w-full text-left px-3 py-3 text-base font-medium text-gray-200 hover:text-white hover:bg-[#1e3a5f] rounded-md" data-id="element-88">
              Bonos
            </button>
            <button onClick={() => scrollToSection('testimonios')} className="block w-full text-left px-3 py-3 text-base font-medium text-gray-200 hover:text-white hover:bg-[#1e3a5f] rounded-md" data-id="element-89">
              Testimonios
            </button>
            <div className="pt-4" data-id="element-90">
              <button onClick={() => scrollToSection('pricing')} className="w-full bg-[#d4a017] hover:bg-[#e5b229] text-[#1e3a5f] font-bold py-3 px-6 rounded-lg transition-colors shadow-md text-center" data-id="element-91">
                COMPRAR AHORA
              </button>
            </div>
          </div>
        </div>}
    </nav>;
}